import * as React from 'react';

function SvgSpecific(props) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15A7 7 0 108 1a7 7 0 000 14zm.4-10.388a.444.444 0 00-.8 0l-.781 1.625a.444.444 0 01-.342.248l-1.787.24a.444.444 0 00-.248.763l1.305 1.244a.444.444 0 01.13.402l-.323 1.774a.444.444 0 00.648.47l1.587-.855a.445.445 0 01.422 0l1.587.856a.444.444 0 00.648-.471l-.323-1.774a.444.444 0 01.13-.402l1.305-1.244a.444.444 0 00-.248-.763l-1.787-.24a.444.444 0 01-.342-.248l-.78-1.625z"
        fill="#F9A600"
      />
    </svg>
  );
}

export default SvgSpecific;
